const state = {
  list: [],
  selectedReport: null,
  onetimeReport: null,
};

const getters = {
  scheduledReports: (state) => state.list,
  selectedScheduledReport: (state) => state.selectedReport,
  onetimeReport: (state) => state.onetimeReport,
};

const actions = {
  async fetchScheduledReports({ commit }, { id }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/scheduledreports/`
    );
    commit("setScheduledReports", response.data);
  },
  async fetchScheduledReport({ commit }, { id, scheduledReportId }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/scheduledreports/${scheduledReportId}`
    );
    commit("setSelectedReport", response.data);
    commit("updateScheduledReport", response.data);
  },
  async createScheduledReport({ commit }, { id, scheduledReport }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/scheduledreports`,
      scheduledReport
    );

    commit("updateScheduledReport", response.data);
  },
  async createOneTimeReport({ commit }, report) {
    commit("setOneTimeReport", report);
  },
  async updateScheduledReport(
    { commit },
    { id, scheduledReportId, scheduledReport }
  ) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/scheduledreports/${scheduledReportId}`,
      scheduledReport
    );
    commit("setSelectedReport", response.data);
    commit("updateScheduledReport", response.data);
  },
  async deleteScheduledReports({ commit }, { userId, reports }) {
    const req = {};

    for (const report of reports) {
      req[`${report.id}`] = {
        method: "delete",
        path: `users/${userId}/scheduledreports/${report.id}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("removeScheduledReport", ids);
  },
  async runScheduledReport(store, { id, scheduledReportId }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/scheduledreports/${scheduledReportId}/run`
    );
    // Create toast to alert user?
    // Update store report item with "queued: true"?
    return response.data;
  },
};

const mutations = {
  setScheduledReports: (state, data) => (state.list = data.data),
  setSelectedReport: (state, data) => (state.selectedReport = data),
  setOneTimeReport: (state, data) => (state.onetimeReport = data),
  addScheduledReport: (state, data) => state.list.push(data),
  updateScheduledReport: (state, data) => {
    state.list = [...state.list, data];
  },
  removeScheduledReport(state, reports) {
    for (const report of reports) {
      state.list = state.list.filter(
        (stateReport) => stateReport.id !== report
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
